import { Badge, BlockStack, Box, Card, Icon, InlineStack,Text } from '@shopify/polaris';
import React from 'react';
import {
    CheckCircleIcon
  } from '@shopify/polaris-icons';
import './index.css'
const Index = ({pageData})=> {
    return (
        <Box>
            <Card>
                <BlockStack gap={400}>
                    <Text variant="headingSm" as="h6">
                    Current store info
                    </Text>
                    <Box>
                    <BlockStack gap={400}>
                        <Card roundedAbove="xs">
                            <Box>Shop owner:  {pageData?.account_info?.shop_owner}</Box>
                            <Box>Store email: {pageData?.account_info?.store_email}</Box>
                        </Card>
                        <Card padding={0} roundedAbove="xs">
                            <Box style={{background:'rgba(243, 243, 243, 1)'}}>
                                <InlineStack  blockAlign="center">
                                    <Box className='store_domain_name store_domain_weight'>Shopify domain name</Box>
                                    <Box className='store_domain_status store_domain_weight'>Status</Box>
                                    <Box className='store_domain_api store_domain_weight'>API health</Box>
                                </InlineStack>
                            </Box>
                            <Box>
                            <InlineStack  blockAlign="center">
                                    <Box className='store_domain_name'>{pageData?.account_info?.shop_domain}</Box>
                                    <Box className='store_domain_status'><Badge tone="success">Active</Badge></Box>
                                    <Box className='store_domain_api'>
                                    <Icon
                                    source={CheckCircleIcon}
                                    tone="success"
                                    /></Box>
                                </InlineStack>
                            </Box>
                        </Card>
                        </BlockStack>
                    </Box>
                </BlockStack>
            </Card>
        </Box>
    );
}

export default Index;
